var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 80",
    width: 50,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.56 1H18.6943C21.9819 1 25.0389 2.68927 26.7883 5.47275L48.8145 40.5173L26.8089 74.623C25.0484 77.3516 22.0231 79 18.7759 79H10.56C5.28015 79 1 74.7198 1 69.44V10.56C1 5.28016 5.28016 1 10.56 1Z",
    fill: "white",
    stroke: "#D6E2B2",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.cb1f58ec022503349c03663c6c754d1f.svg";
export { ForwardRef as ReactComponent };